<template>
	<div style="display: flex; width:100%;" v-hotkey="keymap">
        <dialogue
            :title="'Are you sure?'"
            :paragraph="'This will move all items to box 1'"
			:button_names="['Yes','No']"
			:show="box_dialogue"
			v-on:dialogue="acceptEmpty"
			v-on:cancel="cancelEmpty"
		></dialogue>
        
        <div style="background-color: rgb(224, 224, 224); padding-right:16px;">
            <p class="title">Box ID</p>
            <input class="textfield" v-on:keyup.enter="changeBox" @blur="changeBox" v-model.lazy="boxNum" tabindex=1></input>
            <button v-on:click="emptyBox">Empty Box</button>
            
            <p class="title">Scan Item</p>
            <input id="scanText" v-on:keyup.enter="addItem" class="textfield" v-model="scanText" tabindex=2></input>
            <button v-on:click="addItem">Add Item</button>
        </div>
        <div style="flex:1; height: calc(100vh - 50px);">
            <layout-1
			:table_name="'Box '+boxNum+' Items'"
			:filter_options=null
			:id=pageid4
			:searchbar=false
			:navbar=false
			:term=boxNum
			:usePages=false
			:key="updateKey"
			style="width:100%; height:100%;"
		></layout-1>
        </div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid4:PAGES.EDIT_INVENTORY_BOX_PAGE,
			pageid5:PAGES.EMPTY_INVENTORY_BOX_PAGE,

			perms:[],
			scanText:'',

            boxNum:'',
            updateKey:0,
            box_dialogue:false,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	mounted () {
		
	},
	methods: {
        changeBox() {
            this.updateKey++;
        },
        scan() {
            document.getElementById("scanText").focus();
        },
        emptyBox() {
            this.box_dialogue = true
        },
        acceptEmpty() {
            api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid5,
						term:this.boxNum,
					}
				}
			).then((res) => {
                this.updateKey++;
			});
        },
        cancelEmpty() {
            this.box_dialogue = false
        },
        addItem(){
			if(this.scanText=='') return;

			const itemVal = 'LDPAV2-'
            console.log(this.scanText)

            if(this.scanText.substr(0,itemVal.length)==itemVal){
				this.scanText = this.scanText.substr(itemVal.length)
			}else if (!Number.isInteger(Number(this.scanText))) {
				return
			}

            if (!Number.isInteger(Number(this.boxNum))) {
				return
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid4,
                        term:this.boxNum,
                        item:this.scanText,
					}
				}
			).then((res) => {
                this.updateKey++;
			});
        },
	},
	computed: {
		keymap() {
			return {
				"ctrl+e": this.scan,
			};
		}
	},
}
</script>

<style scoped>
.textfield{
	margin:16px;
	font-size:24px;
}
.title {
	margin:16px;
    margin-bottom:0px;
	font-size:24px;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Box_Items.vue